/**
 *  유저 리스트 필터 옵션 모델
 */
export const ACCOUNT_USER_LIST_FILTER_OPTION_MODEL = {
  /**
   *  식별번호
   */
  userId: null,
  /**
   *  계정상태
   */
  status: null,
  /**
   *  로그인 타입
   */
  loginType: null,
  /**
   *  이름
   */
  name: null,
  /**
   *  아이디
   */
  account: null,
  /**
   *  핸드폰
   */
  cellPhone: null,
  /**
   *  이메일
   */
  email: null,
  /**
   *  레퍼럴 코드
   */
  referralCode: null,
  /**
   *  sms 푸시동의
   */
  smsPush: null,
  /**
   *  가입일자
   */
  createDate: {
    startDate: null,
    endDate: null,
  },
};

/**
 *  유저 랭킹 필터 옵션 모델
 */
export const ACCOUNT_USER_RANK_FILTER_OPTION_MODEL = {};

/**
 *  유저 리스트 정렬 옵션 모델
 */
export const ACCOUNT_USER_LIST_SORT_OPTION_MODEL = [
  {
    id: 'createDate',
    desc: true,
  },
];

/**
 *  유저 랭킹 리스트 정렬 옵션 모델
 */
export const ACCOUNT_USER_RANK_SORT_OPTION_MODEL = [
  {
    id: 'purchaseAmount',
    desc: true,
  },
];

/**
 *  유저 상세 > 1:1 문의 내역 정보 > 1:1 문의 리스트 필터 옵션 모델
 */
export const ACCOUNT_USER_DETAIL_CS_INQUIRY_HISTORY_LIST_FILTER_OPTION_MODEL = {
  /**
   *  답변 처리 상태
   */
  isResponse: null,
  /**
   *  1:1 문의 ID
   */
  inquiryId: null,
  /**
   *  질문 유형
   */
  type: null,
  /**
   *  질문내용
   */
  question: null,
  /**
   *  답변내용
   */
  answer: null,
  /**
   *  답변 작성자
   */
  replyAuthor: null,
  /**
   *  답변 작성자 메모
   */
  memo: null,
  /**
   *  답변 일자
   */
  answerDate: {
    startDate: null,
    endDate: null,
  },
  /**
   *  질문 작성 일자
   */
  createDate: {
    startDate: null,
    endDate: null,
  },
};

/**
 *  유저 상세 > 상품 문의 내역 정보 > 상품 문의 리스트 필터 옵션 모델
 */
export const ACCOUNT_USER_DETAIL_CS_QNA_HISTORY_LIST_FILTER_OPTION_MODEL = {
  /**
   *  상품 문의 ID
   */
  id: null,
  /**
   *  답변 처리 상태
   */
  isResponse: null,
  /**
   *  상태
   */
  status: null,
  /**
   *  상품번호
   */
  productId: null,
  /**
   *  상품명
   */
  productName: null,
  /**
   *  상점명
   */
  storeName: null,
  /**
   *  상점 ID
   */
  storeId: null,
  /**
   *  질문내용
   */
  question: null,
  /**
   *  답변내용
   */
  answer: null,
  /**
   *  답변 일자
   */
  answerDate: {
    startDate: null,
    endDate: null,
  },
  /**
   *  문의 작성 일자
   */
  createDate: {
    startDate: null,
    endDate: null,
  },
};

/**
 *  유저 상세 > 상품 후기 정보 > 상품 후기 리스트 필터 옵션 모델
 */
export const ACCOUNT_USER_DETAIL_CS_REVIEW_HISTORY_LIST_FILTER_OPTION_MODEL = {
  /**
   *  상품 후기 ID
   */
  reviewId: null,
  /**
   *  상품 리뷰의 상태
   */
  status: null,
  /**
   *  상품 리뷰의 별점
   */
  rate: null,
  /**
   *  상품 리뷰의 첨부파일 존재 여부
   */
  isAttachmentExists: null,
  /**
   *  상품 리뷰의 상품 id
   */
  productId: null,
  /**
   *  상품 리뷰의 상품명
   */
  productName: null,
  /**
   *  상품 리뷰의 상점명
   */
  storeName: null,
  /**
   *  상품 리뷰의 상점 ID
   */
  storeId: null,
  /**
   *  상품 리뷰의 상품 주문번호
   */
  orderItemId: null,
  /**
   *  상품 리뷰의 구매평
   */
  content: null,
  /**
   *  상품 리뷰의 작성일
   */
  createDate: {
    startDate: null,
    endDate: null,
  },
};

/**
 *  유저 상세 > 팔로우한 태그 정보 > 유저 태그 타임라인 리스트 정렬 옵션 모델
 */
export const ACCOUNT_USER_DETAIL_TAG_LOG_LIST_SORT_OPTION_MODEL = [
  {
    id: 'createDate',
    desc: true,
  },
];
